export const HALCYON_DESIGNEES = [
    {
        name: "James McGowan",
        address: "25 Broad St, Fir 2, Red Bank, NJ 07701",
        caf: "0315-23889R",
        ptin: "P02537601",
        telephone: "732-691-4928",
        fax: "631-675-1704",
        checked: false,
    },
    {
        name: "Elizabeth Boonin",
        address: "95 Smithtown Blvd, Smithtown, NY 11787",
        caf: "0310-03870R",
        ptin: "P01627702",
        telephone: "732-691-4998",
        fax: "631-675-1704",
        checked: false,
    },
];

interface Reason {
    actionCode: string;
    isBlocking: boolean;
    scenario: string;
    emailScenario: string;
    nextAction: string;
    faqLink: boolean;
    subjectTag: string;
    message: string;
    tag: string;
}

export interface DesigneeInfo8821 {
    name: string;
    address: string;
    caf: string;
    ptin: string;
    PTIN?: string;
    telephone: string;
    fax: string;
    checked: boolean;
    "CAF No"?: string;
    "Telephone No"?: string;
    "Fax No"?: string;
}

export interface Table8821 {
    typeOfTaxInformation: string;
    formNumber: string;
    years: number[];
    specificTaxMatters: string
}

interface Extracted8821Individual {
    taxpayerType: 'individual';
    name: string;
    firstName: string;
    lastName: string;
    addressLine1: string;
    addressline1: string;
    city: string;
    state: string;
    zipcode: string;
    tin: string;
    table: Table8821[];
    box4: boolean;
    signatureStatus: boolean;
    signature_status: boolean;
    signatureDate: string;
    designees: DesigneeInfo8821[];
}

interface Extracted8821Business {
    taxpayerType: 'business';
    businessName: string;
    addressline1: string;
    addressLine1?: string;
    city: string;
    state: string;
    zipcode: string;
    tin: string;
    table: Table8821[];
    box4: boolean;
    signatureStatus: boolean;
    signature_status: boolean;
    signatureDate: string;
    designees: DesigneeInfo8821[];
}

export type Extracted8821 = Extracted8821Individual | Extracted8821Business

interface Extracted1177 {
    name: string;
    firstName: string;
    lastName: string;
    signature_status: boolean;
    signatureStatus: boolean;
    signatureDate: string;
}

interface ParseTemplate {
    version: string;
    pageNumber: number;
    extractedData: Extracted8821 | Extracted1177 | unknown;
}

export interface Parse8821Response extends ParseTemplate {
    type: "8821";
    extractedData: Extracted8821;
    overallConfidence: number;
    requiresManualReview: boolean;
    fieldConfidence: {
        taxpayerName: {
            value: number;
            factors: string[];
            issues: string[]
        };
        designees: {
            value: number;
            factors: string[];
            issues: string[]
        };
        table: {
            value: number;
            factors: string[];
            issues: string[];
        }
    };
    extractionMetadata: {
        documentQuality: string;
        scanQuality: string;
        extractionNotes: string
    }
}

export interface Parse1177Response extends ParseTemplate {
    type: "1177";
    extractedData: Extracted1177 | Extracted1177[];
}

export interface ParseUnknownResponse extends ParseTemplate {
    type: string;
    extractedData: unknown;
}

export type ParseFormResponse = Parse8821Response | Parse1177Response;

export interface BusMessage {
    irsIncomeId: string;
    FICode: string;
    hasIrsAccount: boolean;
    hasIndividual8821: boolean;
    firstName: string;
    lastName: string;
    tin: string;
    loanNumber: string;
    institutionCode: string;
    signed8821ContainerName: string;
    signed8821BlobName: string;
    signedTranscriptBlobName: string;
    businessName: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    zipCode: string;
    authFormValidationNotes: string[];
    consentFormValidationNotes: string[];
    authFormRawValues: {
        tin: string | null;
        ein: string | null;
        name: string | null;
        address: string | null;
        telephone: string | null;
        caf1: string | null;
        caf2: string | null;
        authorize: boolean;
        taxInformation: string | null;
        isSigned: boolean;
        signature: string | null;
        signName: string | null;
        signDate: string | null;
    },
    consentFormRawValues: {
        name: string | null;
        isSigned: boolean
        signature: string | null;
        signDate: string | null;
    }
}

export interface AutomationData {
    blobName: string;
    extracted: ParseFormResponse[];
    body: BusMessage;
    errors: {
        actionNeeded: Reason;
        issue: string;
    }[];
    warns: {
        actionNeeded: Reason;
        issue: string;
    }[];
    validations: any;
    taxYears: number[];
    missingYears: number[];
    actionReason?: Reason;
    pdf: string;
    page8821?: string;
}

export interface AutomationParams {
    FICode: string;
    irsIncomeId: string;
    message: string;
}
